var _clipPath, _clipPath2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 447",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-95.3204,-1703.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,412.889L99,439.889L99,511.889L27,511.889L27,412.889L72,412.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,511.889L27,412.889L99,412.889L99,511.889L27,511.889Z",
    style: {
      fill: "url(#_Linear2)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,412.889L99,439.889L99,511.889L27,511.889L27,412.889L72,412.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(113,146,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,412.889L99,439.889L72,439.889L72,412.889Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5,426.389L72,412.889L99,439.889L85.5,453.389L58.5,426.389Z",
    style: {
      fill: "url(#_Linear4)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,412.889L99,439.889L72,439.889L72,412.889Z",
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinejoin: "bevel",
      stroke: "rgb(113,146,161)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "37px",
    y: "503.889px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 28,
      fill: "rgb(76,108,123)"
    }
  }, "TXT"))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-4.3e-06,-98.9995,98.9995,-4.3e-06,63,511.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(200,212,219)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(13.5003,-13.5003,13.5003,13.5003,72,439.889)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "81%",
    style: {
      stopColor: "rgb(197,209,216)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(146,166,177)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlain);
export default __webpack_public_path__ + "static/media/plain.f558b73cfc02ba6fb369945a001b890f.svg";
export { ForwardRef as ReactComponent };